import { useAppSelector } from 'hooks/useAppSelector';
import {
  selectEssentialsFormQuoteResult,
  selectEssentialWorkflowStatus,
} from 'routes/essential-workspace/state/form.selectors';
import { selectEssentialFormInfos } from 'state/essential/infos/selectors';

export function useQuotePriceInfo(tabId: string) {
  const quoteResult = useAppSelector(state => selectEssentialsFormQuoteResult(state, tabId));
  const quoteState = useAppSelector(state => selectEssentialFormInfos(state, tabId)?.quoteState);
  const status = useAppSelector(state => selectEssentialWorkflowStatus(state, tabId));

  const price = quoteResult?.solveResult;

  const format =
    quoteResult?.solveResultFormat === undefined || quoteResult?.solveResultFormat === 'Percent'
      ? 'percent'
      : 'currency';

  const isStrikethrough = status !== 'priced' && quoteState === 'Inconsistent';

  return { format, price, isStrikethrough } as const;
}
